import { useEffect } from 'react';
import { dismissSiteMenus } from '../lib/pageEffects';

export function useMenuDismiss() {
  useEffect(() => {
    document.addEventListener('keydown', dismissSiteMenus);
    return () => document.removeEventListener('keydown', dismissSiteMenus);
  }, []);
}

export function useFocusOnMount(ref, scroll = false) {
  useEffect(() => {
    ref.current?.focus();
    if (scroll) ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [ref, scroll]);
}

export function useScrollToBottom(ref, messages, busy, error) {
  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [ref, messages, busy, error]);
}

export function useEscapeDismiss(enabled, dismiss) {
  useEffect(() => {
    if (!enabled) return;
    const onKey = event => { if (event.key === 'Escape') dismiss(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [enabled, dismiss]);
}